import { cx } from './cx';
import { Text } from './Text';
import { useT } from '../../modules/i18n';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'size-4 border-2',
  md: 'size-6 border-2',
  lg: 'size-8 border-[3px]',
};

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Centered label below the spinner — for full-panel loading states. */
  label?: string;
  /** Center within the available space with vertical padding. */
  center?: boolean;
  className?: string;
}

/**
 * Loading spinner — the shared busy indicator (replaces ad-hoc MUI
 * CircularProgress across panels). Brand-colored ring on a faint track.
 */
export const Spinner = ({
  size = 'md',
  label,
  center = false,
  className,
}: SpinnerProps) => {
  const t = useT();
  const spinner = (
    <span
      role="status"
      aria-label={label ?? t('ui.spinner.loadingLabel')}
      className={cx(
        'inline-block animate-spin rounded-full border-default border-t-brand-solid',
        sizeClasses[size],
        className,
      )}
    />
  );
  if (!label && !center) return spinner;
  return (
    <div className={cx('flex flex-col items-center gap-3', center && 'py-10')}>
      {spinner}
      {label && (
        <Text variant="body" tone="tertiary">
          {label}
        </Text>
      )}
    </div>
  );
};
